
import { Component , Prop } from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';


interface IDisableAccess {
  description?: string
}

@Component
export default class DisableAccess  extends tsx.Component<IDisableAccess> {
  
  @Prop() public description?: string
  
  render() {  
    
    return (
      <div class='disableAccess-container'>
        <img class='img' src={require('@/assets/img/disable.png')} />
        <pre class='text'>{this.$props.description}</pre>
      </div>
    )
  } 
  
}